import { Base, Component, Inject } from '@/vue-property-decorator'
import { ImgEvents } from '@/components/img'
import { VerticalProps } from '../basePropsConfig'
import style from './style.module.scss'
/** 收藏图标 后面可能要扩展出未收藏和已收藏两种状态,后面再说*/
@Component<AdvertisementBox>({
  name: 'AdvertisementBox'
})
export default class AdvertisementBox extends Base<
  unknown,
  unknown,
  ImgEvents
> {
  /** 接收根级传入的Props */
  @Inject() cardProps!: Required<VerticalProps>

  render() {
    const { imgUrl, isAtSwiper, atSwiperDomId } = this.cardProps
    return (
      // 主体内容图片
      <my-img
        class={{
          ['advertisement-box']: true,
          [style['advertisement-box']]: true
        }}
        options={{ type: 'div', lazy: !isAtSwiper, immediate: isAtSwiper }}
        syncGroupsSrc={isAtSwiper}
        syncGroupsWrapId={atSwiperDomId}
        src={imgUrl as string}
        onLoadedResult={(it) => this.$emit('loadedResult', it)}
      >
        {this.$slots.default}
      </my-img>
    )
  }
}
